module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "imagep"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "32",
      "src": "images/stara.jpg",
      "width": "109"
    }
  })])])]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _c('p', {
    staticClass: "chtitle",
    attrs: {
      "id": "rch02"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_c('span')]), _c('a', {
    attrs: {
      "href": "#/Contents#ch02"
    }
  }, [_vm._v("ABOUT THE SPECIAL FORCES")])]), _vm._v(" "), _c('p', {
    staticClass: "normalta"
  }, [_c('span', [_vm._v("Special operations soldiers are considered the elite representatives of their respective branch of service. The Air Force has the Pararescue, the Navy has its SEAL (Sea, Air, Land) teams, the Marine Corps has Force Reconnaissance (or Force Recon), and the Army has its Green Berets and Ranger units. To be selected for one of these elite teams, one must successfully complete rigorous physical and mental tests under a high level of stress. For example, to become an Air Force Pararescueman, you must be able to swim 50 meters underwater; a Navy SEAL needs to be able to swim 500 meters in 8 to 9 minutes; a Marine Force Recon must be able to tread water for 40 minutes; an Army Ranger needs to run 5 miles in under 40 minutes.")])]), _vm._v(" "), _c('p', {
    staticClass: "normalt"
  }, [_c('span', [_vm._v("The path to becoming a special ops soldier is not an easy one. Many soldiers train weeks, months and even years to prepare their mind and body for the challenges that they’ll encounter during the selection phase. Any special ops solider will tell you that while the physical stress and sacrifice is challenging, successfully completing the selection course makes it all worthwhile.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b506226","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chapter02.vue
// module id = 78
// module chunks = 0